import { Injectable } from '@angular/core';
import { getHeaders } from '../utils/geral';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Opcoes } from '../models/usuario/opcoes';
import { Store } from '@ngrx/store';
import { AppState } from '../store';
import { KeycloakProfile } from 'keycloak-js';
import { UsuarioNovo } from '../store/usuario/usuario.actions';
import { AuthService } from './auth.service';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UsuarioService {
  uri = environment.urlApi.concat('/v1');
  configUser: any;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private authService: AuthService
  ) {}

  gravarConfigUsuario(dados: Opcoes) {
    let uri = this.uri + '/usuario/opcoes';
    return this.http.post<any>(uri, dados, { headers: getHeaders() });
  }

  obterConfigUsuario(idUsuario: string) {
    let uri = this.uri + `/usuario/${idUsuario}/opcoes`;
    return this.http.get<any>(uri, { headers: getHeaders() }).pipe(
      tap((elements: any) => {
        return elements;
      })
    );
  }

  obterUsuarioComOpcoes() {
    return new Promise<KeycloakProfile>((resolve, reject) => {
      this.authService.loadUserProfile().then((u: any) => {
        let user = u;
        if (user.tipoUsuario) {
          let profile: KeycloakProfile = <KeycloakProfile>u;
          resolve(profile);
        } else {
          let prom = this.obterConfigUsuario(user.id);
          prom.subscribe((config) => {
            user.tipoUsuario = config.opcoes.TELA_VISAO;

            this.store.dispatch(new UsuarioNovo({ user: user }));
            resolve(user);
          });
        }
      });
    });
  }

  listGroups() {
    let uri = this.uri + `/usuario/grupos`;
    return this.http.get<any>(uri, { headers: getHeaders() });
  }
}
